import { render, staticRenderFns } from "./OptionShowDetailsTab.vue?vue&type=template&id=d7af007c"
import script from "./OptionShowDetailsTab.vue?vue&type=script&lang=ts"
export * from "./OptionShowDetailsTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports